var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.604 14.125H1.875V5.39836H4.39967V4.52336H1V15H11.479V11.605H10.604V14.125ZM5.802 1V10.1933H15V1H5.802ZM14.125 9.31834H6.677V1.875H14.125V9.31834Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }